import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=1ccd084c&scoped=true&lang=pug&"
import script from "./confirm.vue?vue&type=script&lang=ts&"
export * from "./confirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd084c",
  null
  
)

export default component.exports